import classnames from 'classnames/bind'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroller'

// Libs
import useLiveMallSearchQuery from '@/hooks/useLiveMallSearchQuery'

// Components
import ExploreLiveList from '@/components/shared/livemallclub/ExploreLiveList'

import MoreButton from '../_shared/MoreButton'
import { StateHandler } from '../_shared/StateHandler'

// Constants
import { FeedType } from '@/types/feed'
import { RoomSearchType } from '@/types/live-mall-search/types'
import { ALL_PAGE_DISPLAY_NUMBER, LIVE_MALL_SEARCH_CATEGORY_MAP } from '../../utils/constants'
import { CategorySharedProps } from '../../utils/types'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const formatFeeds = (apiData: RoomSearchType[] | undefined): FeedType[] => {
  if (!apiData) return []
  return apiData.map((item) => ({
    type: 'video',
    meta: {
      roomId: item.roomId,
      title: item.title,
      coverPhotoUrl: item.coverPhotoUrl,
      roomDesc: item.roomDesc,
      countryCode: item.countryCode,
      ownerName: item.merchantName || item.nickName,
      ownerMemberInfoId: item.memberInfoId,
      startTime: item.startTime,
      liveTime: item.liveTime,
      preferencesTag: [],
      liveType: item.liveType,
      liveCloseTime: item.liveCloseTime,
      dummyViews: item.dummyViews,
      ownerAvatarUrl: item.merchantHeadshotUrl || item.headshotUrl,
      isFavorite: item.isLike,
      liveSourceType: item.liveSourceType,
      isVip: item.isVip,
      hasAgeLimit: item.hasAgeLimit,
      ageLimit: item.ageLimit,
    },
    roomProducts: [],
  }))
}

const LivesContent = ({ allQueryResult, ...props }: CategorySharedProps) => {
  const router = useRouter()
  const { keyword, category } = router.query
  const isAllCategory = category === 'all' || !category

  const [feeds, setFeeds] = useState<FeedType[]>([])
  const isEmpty = feeds.length === 0
  const {
    data: roomsQueryResult,
    handleNextPage,
    hasNextPage,
    isFetching,
  } = useLiveMallSearchQuery({
    keyword: String(keyword),
    type: LIVE_MALL_SEARCH_CATEGORY_MAP.LIVE,
    enabled: !isAllCategory && !!keyword,
  })
  const queryResult = allQueryResult || roomsQueryResult
  const needShowMore = isAllCategory && formatFeeds(queryResult?.roomList).length > ALL_PAGE_DISPLAY_NUMBER

  const loadMore = () => {
    handleNextPage()
  }

  useEffect(() => {
    if (queryResult) {
      const formattedFeeds = formatFeeds(queryResult.roomList)
      setFeeds(isAllCategory ? formattedFeeds.slice(0, ALL_PAGE_DISPLAY_NUMBER) : formattedFeeds)
    }
  }, [queryResult])

  return (
    <StateHandler isFetching={isFetching} isEmpty={isEmpty}>
      <div className={cx('live-search-results')} {...props}>
        <InfiniteScroll pageStart={0} loadMore={loadMore} hasMore={hasNextPage}>
          <ExploreLiveList feeds={feeds} key={0} refetchCurrentPage={() => {}} useFavoriteState />
        </InfiniteScroll>
        {needShowMore && <MoreButton category='live' />}
      </div>
    </StateHandler>
  )
}

export default LivesContent
